/* =========================================================================
   Cart-drawer cross-sell — "Frequently Bought Together" (CRO report §02.4).

   Shows the store's ADD-ON products: every live product in the Stands
   collection (easels + display stands). Merchandising is curated in admin —
   the collection is the source of truth, so adding, removing or reordering a
   stand there changes this block with no theme edit. cart-drawer.liquid emits
   the published, in-stock handles into [data-af-addons]; we hydrate each one
   from /products/{handle}.js for full variant data (prices in cents).

   Stands already in the cart are dropped, so the block empties out rather
   than re-offering something the shopper has.

   Was previously "Complete your gallery" — a recommendations-API block that
   pushed more frames (same finish, another size) using mined co-purchase
   pairs. That scoring logic is in git history if the frame push is ever
   wanted back alongside these add-ons.

   Quick-pick popover + add-to-cart live in the shared module
   (af-quick-pick.js, loaded just before this file).
   ========================================================================= */
(function () {
  var inFlight = false;
  var lastKey = null;
  var productCache = {};

  var money = window.AFQuickPick.money;
  var esc = window.AFQuickPick.esc;

  function withWidth(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  /* There can be up to two mounts: the desktop side-panel ([data-af-xsell-drawer] >
     [data-af-crosssell]) and the in-cart footer fallback (narrow screens). Render into
     both; CSS shows only the one that fits the viewport. */
  function mountsAll() { return Array.prototype.slice.call(document.querySelectorAll('[data-af-crosssell]')); }
  function wrappersAll() { return Array.prototype.slice.call(document.querySelectorAll('[data-af-xsell-drawer]')); }
  function hideAll() {
    mountsAll().forEach(function (e) { e.hidden = true; e.innerHTML = ''; });
    wrappersAll().forEach(function (w) { w.hidden = true; });
  }

  /* Add-on handles in collection order (each collection is sorted in admin).
     `soft` swaps the Stands pool for Blankets & Throws — offering an easel next to a
     throw is the wrong basket, and a throw's natural add-on is another throw. */
  function addonHandles(soft) {
    var el = document.querySelector('[data-af-addons]');
    if (!el) return [];
    var attr = soft && el.getAttribute('data-af-addons-soft') ? 'data-af-addons-soft' : 'data-af-addons';
    return (el.getAttribute(attr) || '').split(',')
      .map(function (h) { return h.trim(); })
      .filter(Boolean);
  }

  /* Decided from the live cart, not from page-load state. */
  function cartIsSoft(cart) {
    return (cart.items || []).some(function (i) {
      return String(i.product_type || '').toLowerCase() === 'blanket';
    });
  }

  /* ---- Rotation & pinning ---------------------------------------------
     SLOTS tiles per drawer open, chosen from the whole qualifying pool:
       - frame carts ALWAYS include the white Floating Shelf (pinned),
       - the rest are a session-stable random sample, order shuffled.
     Session-stable = one seed per browser session, so the tiles don't
     reshuffle while someone shops (that reads as a glitch), but DO vary
     across sessions -- which is what generates exploration data for the
     pairing report. Impressions already record product + slot + anchor,
     so no extra tracking is needed. */
  /* 3 tiles everywhere. Mobile briefly ran 2 (stacked cards crowded the
     drawer), but the in-cart mount is now a horizontal snap-scroll row, so
     tile count no longer costs vertical space. */
  function slots() { return 3; }
  var PIN_FRAME_SHELF = 'floating-shelf-lipped-ledge-engineered-wood-wall-mount';

  function sessionSeed() {
    try {
      var v = sessionStorage.getItem('af_xsell_seed');
      if (!v) {
        v = String((Math.random() * 0x7fffffff) | 0);
        sessionStorage.setItem('af_xsell_seed', v);
      }
      return parseInt(v, 10) || 1;
    } catch (e) { return 1; } /* Safari private mode: fixed order, still fine */
  }

  /* mulberry32 -- tiny deterministic PRNG so the same seed always yields the
     same selection within a session. */
  function rng(seed) {
    var t = seed >>> 0;
    return function () {
      t += 0x6D2B79F5;
      var r = Math.imul(t ^ (t >>> 15), 1 | t);
      r = (r + Math.imul(r ^ (r >>> 7), 61 | r)) ^ r;
      return ((r ^ (r >>> 14)) >>> 0) / 4294967296;
    };
  }

  function seededShuffle(arr, rand) {
    var a = arr.slice();
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(rand() * (i + 1));
      var tmp = a[i]; a[i] = a[j]; a[j] = tmp;
    }
    return a;
  }

  function cartHasFrames(cart) {
    return (cart.items || []).some(function (i) {
      return /frame/i.test(String(i.product_type || ''));
    });
  }

  /* handles = the qualifying pool (already excludes items in the cart). */
  function selectUpsells(handles, cart, soft) {
    var rand = rng(sessionSeed());
    var pinned = [];
    if (!soft && cartHasFrames(cart)) {
      var shelfInCart = (cart.items || []).some(function (i) {
        return i.handle === PIN_FRAME_SHELF;
      });
      if (!shelfInCart) pinned = [PIN_FRAME_SHELF];
    }
    var pool = handles.filter(function (h) { return h !== PIN_FRAME_SHELF; });
    var sampled = seededShuffle(pool, rand).slice(0, Math.max(0, slots() - pinned.length));
    /* shuffle AGAIN so the pinned shelf lands in a random slot too --
       otherwise slot 1 is always the shelf and the position report is
       confounded for frame carts. */
    return seededShuffle(pinned.concat(sampled), rand);
  }

  /* handle -> strategy id for whatever is currently rendered. Rebuilt on every
     render, because a cart change can hand the tiles to a different rule. */
  var strategyByHandle = {};
  /* handle -> the variant a strategy named, when it named one. A strategy that
     offers "the 6in acrylic stand" means that variant, not its parent: the
     tile shows its price and photo and ADD puts exactly it in the cart. */
  var variantByHandle = {};

  function pinnedVariant(p) {
    var id = variantByHandle[p.handle];
    if (!id) return null;
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (String(vs[i].id) === String(id)) return vs[i];
    }
    return null;
  }

  /* Price, photo and label for a tile. Parent products keep "From" when their
     variants differ in price, because that is honest; a named variant has one
     price and says it. */
  function offerView(p, fallbackImg) {
    var v = pinnedVariant(p);
    if (v) {
      return {
        price: money(v.price),
        img: (v.featured_image && v.featured_image.src) || fallbackImg,
        label: v.title && v.title !== 'Default Title' ? v.title : ''
      };
    }
    return {
      price: (p.price_min !== p.price_max ? 'From ' : '') + money(p.price_min),
      img: fallbackImg,
      label: ''
    };
  }

  /* The same product narrowed to its one pinned variant, so the quick picker
     takes its existing no-choice path and adds it directly instead of asking
     the shopper to pick a size the strategy already chose. */
  function narrowTo(p, v) {
    var q = {};
    for (var k in p) if (Object.prototype.hasOwnProperty.call(p, k)) q[k] = p[k];
    q.variants = [v];
    q.options = (p.options || []).map(function (opt, i) {
      var val = v['option' + (i + 1)];
      return { name: opt.name, position: opt.position, values: val != null ? [val] : opt.values };
    });
    return q;
  }

  function fetchProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) { productCache[handle] = p; return p; });
  }

  function render() {
    var els = mountsAll();
    if (!els.length || inFlight) return;
    inFlight = true;
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      /* Give the collector the cart context BEFORE any event fires, so every
         impression carries the product it was shown alongside. */
      if (window.AFUpsell) window.AFUpsell.setCartContext(cart);
      assignFbtLayout(cart);
      if (!cart.items || !cart.items.length) { hideAll(); lastKey = null; inFlight = false; return; }
      /* Which layout is about to render decides how many tiles there are and
         which strategies may fill them. Known here because assignFbtLayout
         has already run. */
      var variantNow = fbtVariant();
      var tallNow = !!TALL[variantNow];
      var placement = tallNow ? 'next_to_cart' : 'in_cart';
      var limit = tallNow ? 2 : slots();

      var soft = cartIsSoft(cart);
      var allHandles = addonHandles(soft);
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.handle] = true; });

      /* Strategies first; the theme's own collection pool is the fallback.
         An empty result -- app unreachable, no rule matching, a rule pointing
         at nothing -- lands on exactly what the cart shows today rather than
         on an empty panel. */
      var strategyStep = (window.AFStrategies)
        ? window.AFStrategies.load()
            .then(function (list) {
              return window.AFStrategies.select(list, cart, placement, limit);
            })
            .catch(function () { return []; })
        : Promise.resolve([]);

      return strategyStep.then(function (chosen) {
        strategyByHandle = {};
        variantByHandle = {};
        var handles;
        if (chosen && chosen.length) {
          handles = chosen.map(function (c) {
            strategyByHandle[c.handle] = c.strategyId;
            if (c.variantId) variantByHandle[c.handle] = c.variantId;
            return c.handle;
          });
        } else {
          var available = allHandles.filter(function (h) { return !inCart[h]; });
          handles = selectUpsells(available, cart, soft);
        }
        if (!handles.length) { hideAll(); inFlight = false; return; }

        var key = handles.join(',') + '|' + Object.keys(inCart).sort().join(',');
        if (key === lastKey && els.every(function (e) { return e.innerHTML; })) { inFlight = false; return; }

        return Promise.all(handles.map(function (h) {
        return fetchProduct(h).catch(function () { return null; });
      })).then(function (res) {
        var products = res.filter(function (p) { return p && p.available !== false; });
        if (!products.length) { hideAll(); inFlight = false; return; }
        lastKey = key;

        var variant = fbtVariant();
        var tall = !!TALL[variant];
        /* Two slots, not three: each one is now half the panel. */
        if (tall) products = products.slice(0, 2);

        var html;
        if (tall) {
          html = '<p class="af-xsell-head">Finish the wall</p><div class="af-xsell-slots">';
          products.forEach(function (p) { html += tallCardHTML(p); });
          html += '</div>';
        } else {
          html = '<p class="af-xsell-head">Frequently Bought Together</p><div class="af-xsell-list">';
          products.forEach(function (p) { html += cardHTML(p); });
          html += '</div>';
        }
        els.forEach(function (e) {
          e.hidden = false;
          e.innerHTML = html;
          e.classList.toggle('af-xsell--tall', tall);
          if (tall) e.setAttribute('data-tall', variant); else e.removeAttribute('data-tall');
          bind(e, products);
        });
        wrappersAll().forEach(function (w) { w.hidden = false; });
        if (!IMPRESSION_FIRED) {
          gaSend('view_item_list', products.map(ga4Item));
          afCollect('impression', products);
          IMPRESSION_FIRED = true;
        }
        inFlight = false;
      });
      });
    }).catch(function () { hideAll(); inFlight = false; });
  }

  /* ---- Tall panel variants (A/B/C) -----------------------------------------
     The side panel splits 50/50 and each half is a lifestyle photo with an
     eyebrow, name, one-line pitch, price and add button. Three treatments:
       tallA  full bleed, copy on a bottom scrim
       tallB  photo on top, copy on paper below
       tallC  full bleed with a floating paper card
     `?fbt=` overrides the assigned bucket (tallA|tallB|tallC|rail|panel) so any
     of them can be compared side by side while previewing. */
  var TALL = { tallA: 1, tallB: 1, tallC: 1 };

  var DEFAULT_TALL = 'tallA';

  /* The desktop placement test ENDED 2026-09-22. tallA won and is now served
     to every desktop cart.

     It beat both other arms on every step of the funnel, not just one:
       tallA  5,684 shown  15 clicked  9 added  5 purchased
       tallB  4,721 shown   3 clicked  1 added  1 purchased
       rail  10,186 shown  12 clicked  2 added  1 purchased
     Small absolute numbers, but clicks, adds and purchases all point the same
     way, and rail had nearly twice tallA's impressions to do it in.

     ?fbt=tallB|rail|tallC still previews the others by hand -- the code stays
     so a future test costs an array, not an archaeology dig. */
  var AB_ARMS = ['tallA'];

  /* ?fbt= sticks for the session, so the choice survives navigating to another
     product instead of having to re-append it to every URL. */
  function fbtOverride() {
    var q = null;
    try {
      q = new URLSearchParams(location.search).get('fbt');
      if (q && (TALL[q] || q === 'panel' || q === 'rail')) {
        sessionStorage.setItem('af_fbt', q);
        return q;
      }
      var saved = sessionStorage.getItem('af_fbt');
      if (saved && (TALL[saved] || saved === 'panel' || saved === 'rail')) return saved;
    } catch (e) { /* private mode — fall through */ }
    return null;
  }

  function fbtVariant() {
    var o = fbtOverride();
    if (o) return o;
    var assigned = fbtLayout();
    if (TALL[assigned]) return assigned;
    /* Not a tall arm: either the in-cart 'rail' arm, or untagged because we are
       below 990px (fbtLayout returns null there, so mobile can neither see the
       side panel nor dilute a desktop test). Both want the card list, which is
       what any non-TALL value produces -- mobile included, since its mount is
       the in-cart one. */
    return assigned || 'rail';
  }

  /* The featured image is usually the packshot; the room shot sells the add-on.
     Prefer media whose alt names it, then the second image, then whatever exists. */
  function lifestyleImage(p) {
    var m = (p.media || []).filter(function (x) {
      return x && x.src && /lifestyle|room|ls\d|scene/i.test(x.alt || '');
    })[0];
    if (m) return m.src;
    if (p.images && p.images.length > 1) return p.images[1];
    return p.featured_image || (p.images && p.images[0]) || '';
  }

  /* Why this add-on belongs next to a frame. Falls back to something honest. */
  var TALL_COPY = {
    'floating-shelf-lipped-ledge-engineered-wood-wall-mount':
      { eyebrow: 'Pairs with your frames', pitch: 'Lean and layer instead of drilling twice.' },
    'floating-shelves-set-of-3-14-in-lipped-ledge':
      { eyebrow: 'Pairs with your frames', pitch: 'Set of three — build height above a sofa.' },
    'black-adjustable-tabletop-easel-stand-for-frames':
      { eyebrow: 'No wall needed', pitch: 'Stand a frame on a console or desk.' },
    'acrylic-display-stand-modern-clear-easel-premium-quality':
      { eyebrow: 'Desk and shelf', pitch: 'Props a frame upright, nearly invisible.' }
  };

  function tallCardHTML(p) {
    var c = TALL_COPY[p.handle] || { eyebrow: 'Goes with your order', pitch: '' };
    var view = offerView(p, lifestyleImage(p));
    var img = view.img;
    var price = view.price;
    var title = view.label ? p.title + ' \u2014 ' + view.label : p.title;
    return '<div class="af-xsell-item af-xsell-slot" data-handle="' + esc(p.handle) + '" data-source="cart-addon">' +
      (img ? '<img class="af-xsell-shot" src="' + esc(withWidth(img, 700)) + '" alt="" loading="lazy">' : '') +
      '<div class="af-xsell-scrim"></div>' +
      '<div class="af-xsell-copy">' +
        '<span class="af-xsell-eyebrow">' + esc(c.eyebrow) + '</span>' +
        '<span class="af-xsell-title">' + esc(title) + '</span>' +
        (c.pitch ? '<span class="af-xsell-pitch">' + esc(c.pitch) + '</span>' : '') +
        '<span class="af-xsell-row">' +
          '<span class="af-xsell-price">' + price + '</span>' +
          '<button type="button" class="af-xsell-add">Add</button>' +
        '</span>' +
      '</div>' +
      '<div class="af-xsell-pick" hidden></div>' +
    '</div>';
  }

  function cardHTML(p) {
    var view = offerView(p, p.featured_image || (p.images && p.images[0]) || '');
    var img = view.img;
    var price = view.price;
    var title = view.label ? p.title + ' \u2014 ' + view.label : p.title;
    return '<div class="af-xsell-item" data-handle="' + esc(p.handle) + '" data-source="cart-addon">' +
      '<div class="af-xsell-row">' +
        (img ? '<img class="af-xsell-img" src="' + esc(withWidth(img, 160)) + '" alt="" loading="lazy">' : '<span class="af-xsell-img"></span>') +
        '<div class="af-xsell-info"><span class="af-xsell-name">' + esc(title) + '</span>' +
        '<span class="af-xsell-price">' + price + '</span></div>' +
        '<button type="button" class="af-xsell-add">Add to Cart</button>' +
      '</div>' +
      '<div class="af-xsell-pick" hidden></div>' +
    '</div>';
  }

  /* ---- GA4: cart-drawer FBT widget instrumentation --------------------
     Standard GA4 merchandising events (per the instrumentation spec):
       view_item_list  = drawer opened with tiles rendered  (denominator)
       select_item     = a tile's ADD TO CART was clicked   (numerator)
     Both carry item_list_id "cart_fbt", so attach rate = select_item / view_item_list.
     We deliberately do NOT emit add_to_cart — Shopify's Web Pixel already fires
     that on every cart-API add, and duplicating it would inflate cart revenue.
     select_item fires on CLICK (intent), not in the success callback. */
  var IMPRESSION_FIRED = false;
  var FBT_LIST = { id: 'cart_fbt', name: 'Cart Drawer \u2014 Frequently Bought Together' };

  function ga4Item(p, i) {
    var vs = p.variants || [];
    var v = pinnedVariant(p) || vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
    return {
      item_id: String(v.sku || v.id || p.id || ''),
      item_name: p.title,
      item_variant: v.title || '',
      price: Number(v.price != null ? v.price : (p.price_min || 0)) / 100,
      currency: 'USD',
      index: i + 1,
      quantity: 1
    };
  }
  function gaSend(name, items) {
    if (typeof window.afTrack !== 'function') return;
    window.afTrack(name, {
      item_list_id: FBT_LIST.id,
      item_list_name: FBT_LIST.name,
      placement: 'cart_drawer_fbt',
      items: items
    });
  }

  /* ---- First-party collection (app proxy) -----------------------------
     Same events as GA4, sent to our own /apps/af-analytics/collect. Kept
     separate from gaSend because the payload shape differs: the app wants
     one row per product with its slot index, GA4 wants an items[] array. */
  /* Desktop FBT layout test: which component rendered this event. Tagged only
     on >=990px viewports (where panel-vs-rail is actually visible); mobile is
     always the rail, so its events stay untagged and can't dilute the test. */
  function fbtLayout() {
    try {
      if (!window.matchMedia('(min-width: 990px)').matches) return null;
      var d = document.querySelector('cart-drawer');
      return (d && d.getAttribute('data-af-fbt')) || null;
    } catch (e) { return null; }
  }

  /* Assigns the desktop layout bucket CLIENT-side from the cart token.
     The Liquid-rendered attribute on <cart-drawer> is baked into page-cached
     HTML, so every visitor inherited the cached cart's bucket — this JS
     overrides it with the visitor's own. djb2 parity of a random token is a
     fair, sticky coin flip; CSS attribute selectors react to the change.
     The bucket set here is also what afCollect reports as abVariant, so the
     theme and the analytics app can never disagree about who saw what. */
  function assignFbtLayout(cart) {
    try {
      var d = document.querySelector('cart-drawer');
      if (!d) return;
      var forced = fbtOverride();
      if (forced) { d.setAttribute('data-af-fbt', forced); return; }
      /* One arm left, so the cart token no longer decides anything -- but the
         hash stays because the moment a second arm is added it has to split
         again, and a token-stable assignment is what stops the layout
         flickering while someone shops. */
      if (AB_ARMS.length === 1) { d.setAttribute('data-af-fbt', AB_ARMS[0]); return; }
      if (!cart || !cart.token) return;
      var t = String(cart.token), h = 5381;
      for (var i = 0; i < t.length; i++) h = ((h << 5) + h + t.charCodeAt(i)) | 0;
      d.setAttribute('data-af-fbt', AB_ARMS[(h >>> 0) % AB_ARMS.length]);
    } catch (e) { /* keep whatever the server rendered */ }
  }

  function afCollect(eventType, products, index) {
    if (!window.AFUpsell) return;
    var list = (index != null) ? [products] : products;
    list.forEach(function (p, i) {
      var vs = p.variants || [];
      var v = pinnedVariant(p) || vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
      window.AFUpsell.track(eventType, {
        placement: 'cart_drawer',
        handle: p.handle,
        title: p.title,
        variantId: v.id || null,
        price: Number(v.price != null ? v.price : (p.price_min || 0)) / 100,
        position: (index != null) ? index : i,
        abVariant: fbtLayout(),
        /* Null when the theme's pool chose this, which is what the report
           reads as "not from a strategy". */
        strategyId: strategyByHandle[p.handle] || null
      });
    });
  }

  function bind(el, products) {
    var byHandle = {};
    products.forEach(function (p) { byHandle[p.handle] = p; });
    el.querySelectorAll('.af-xsell-item').forEach(function (item, idx) {
      var p = byHandle[item.getAttribute('data-handle')];
      if (!p) return;
      item.querySelector('.af-xsell-add').addEventListener('click', function () {
        gaSend('select_item', [ga4Item(p, idx)]);
        afCollect('click', p, idx);
        openPick(item, p);
      });
    });
  }

  function openPick(item, p) {
    var pick = item.querySelector('.af-xsell-pick');
    var scope = item.closest('.af-xsell') || document;
    scope.querySelectorAll('.af-xsell-pick').forEach(function (x) { if (x !== pick) { x.hidden = true; x.innerHTML = ''; } });
    if (!pick.hidden) { pick.hidden = true; pick.innerHTML = ''; return; }
    var pinned = pinnedVariant(p);
    window.AFQuickPick.open(pick, pinned ? narrowTo(p, pinned) : p, {
      source: item.getAttribute('data-source') || 'cart-addon',
      onAdded: function (variant) {
        /* Only a confirmed add reaches here with a variant; an error passes null. */
        if (variant && window.AFUpsell) {
          window.AFUpsell.track('add', {
            placement: 'cart_drawer',
            handle: p.handle,
            title: p.title,
            variantId: variant.id,
            price: variant.price / 100,
            abVariant: fbtLayout(),
            strategyId: strategyByHandle[p.handle] || null
          });
        }
        lastKey = null;
        render();
      }
    });
  }

  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    // Repopulate when the drawer contents are replaced (add / qty / remove) and on open.
    new MutationObserver(function () {
      if (!drawer.classList.contains('active')) return;
      // A cart re-render wipes any mount inside #CartDrawer — repopulate when one goes empty.
      if (mountsAll().some(function (e) { return !e.innerHTML; })) render();
    }).observe(drawer, { childList: true, subtree: true });
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) render();
      else IMPRESSION_FIRED = false; // next open counts as a fresh impression
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState !== 'loading') render();
  else document.addEventListener('DOMContentLoaded', render);
})();
